<div id="searchoption" class="panel-collapse">
	<div class="panel-body">
		<form class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-4 control-label">Add Points</label>

				<div class="col-sm-8 col-md-8 col-lg-6">
					<select [disabled]="LoadingPointsItems" class="form-control" name="PointsItemID" [(ngModel)]="SelectedPointsItemID">
						<option value="" style="display: none"></option>
						<option *ngFor="let p of lstPointsItem" [ngValue]="p.PointsItemID">
							{{ p.PointsItemDesc }} ({{ p.PointsItemValue }}
							Points)
						</option>
					</select>

					<br />
					<div *ngIf="errorMessage" class="alert alert-danger box-msg" role="alert">
						{{ errorMessage }}
					</div>
					<div *ngIf="AddProcessing" class="warning box-msg" role="warning">Processing. Please wait...</div>

					<td>
						<button
							[disabled]="LoadingPointsItems"
							type="button"
							class="btn btn-primary"
							[disabled]="AddProcessing"
							(click)="submitClick()"
							href="javascript:void(0);"
						>
							Submit
						</button>
						<button [disabled]="LoadingPointsItems" type="button" class="btn btn-danger" (click)="cancelClick()" href="javascript:void(0);">
							Cancel
						</button>
					</td>
				</div>
			</div>
		</form>
	</div>
</div>
